enum AttachmentRequirementTypeIds {
  attachmentOptional = 'cecf27f5-4a8b-4b08-9d84-cc90e5e9b8f0',
  attachmentRequired = '04fe512d-51e7-4acf-bfe8-27fa16f4f046',
}

export { AttachmentRequirementTypeIds }
